var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.8 16.1",
    style: {
      enableBackground: "new 0 0 15.8 16.1"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.users-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "users-svg",
    d: "M1.7,15.3h7.4c0.6,0,1-0.5,0.9-1c-0.3-1.5-1.3-4.2-4.6-4.2c-3.3,0-4.3,2.7-4.6,4.2C0.7,14.9,1.2,15.3,1.7,15.3z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "users-svg",
    d: "M11.7,10.1c2.1,0,2.9,2.1,3.3,3.7c0.2,0.8-0.5,1.6-1.3,1.6h-0.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "users-svg",
    d: "M5.5,6.3c1.5,0,2.8-1.2,2.8-2.7S7,0.8,5.5,0.8c-1.5,0-2.7,1.2-2.7,2.8S3.9,6.3,5.5,6.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "users-svg",
    d: "M10.7,6.3c1.5,0,2.5-1.2,2.5-2.7s-1-2.8-2.5-2.8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.3cafe3144c47deb6d1da477ae64d3794.svg";
export { ForwardRef as ReactComponent };